/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createOperatorNode } from '../../factoriesAny.js';
export var OperatorNodeDependencies = {
  NodeDependencies,
  createOperatorNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesOperatorNode.generated.js
// module id = LuSo
// module chunks = 3